<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        centered
        size="md"
        id="cadastrar-vaga-unidade"
        title="Cadastrar Vagas"
    >
        <load mode="table" v-if="load" />
        <form
            v-else
            @submit.prevent="submit"
            class="row d-flex justify-content-end"
        >
            <form-select
                label="Unidade de acolhimento"
                :itens="unidades"
                v-model="item.unidade_id"
                :required="true"
                @selected="changePublico"
            />
            <form-select
                label="Natureza"
                :itens="$root.arrays.acolhimento_naturezas"
                v-model="item.natureza"
                :required="true"
            />
            <form-select
                v-model="item.publico_alvo"
                :itens="publico_alvo"
                label="Publico-alvo"
                :required="true"
                :multiple="true"
            />
            <form-input
                type="text"
                v-model="item.desc_publico_alvo"
                label="Descrição Público-Alvo"
                v-show="mostrarDescricao"
                :required="mostrarDescricao"
            />
            <form-input
                type="number"
                v-model="item.vagas"
                label="Quantidade de vagas"
                :required="true"
                min="1"
            />
            <button class="btn btn-success btn-sm mx-3" type="submit">
                <i class="mdi mdi-content-save"></i>
                Salvar
            </button>
        </form>
    </b-modal>
</template>
<script>
export default {
    data() {
        return {
            unidades: [], 
            item: {},
            load: false,
            publico_alvo: this.$root.arrays.acolhimento_publico_alvo,
        };
    },
    mounted() {
        this.getUnidades();
    },
    watch: {
        'item.publico_alvo'(novosValores) {
            // Se a opção 35 não estiver selecionada, limpa o campo de descrição
            if (!novosValores?.some(opcao => opcao === 35 || opcao.id === 35)) {
                this.item.desc_publico_alvo = '';
            }
        },
    },
    computed: {
        mostrarDescricao() {
            return this.item.publico_alvo?.some(opcao => opcao === 35 || opcao.id === 35);
        }
    },
    methods: {
        changePublico() {
            let unidade = this.unidades.filter(
                (unidade) => unidade.id == this.item.unidade_id
            );
            let subtipo = unidade[0].subtipo_nome;
            if (subtipo == "RESIDÊNCIA INCLUSIVA") {
                this.publico_alvo = this.$root.arrays.acolhimento_publico_alvo;
            }
            if (
                subtipo ==
                "ABRIGO INSTITUCIONAL (INSTITUIÇÃO DE LONGA PERMANÊNCIA PARA IDOSOS - ILPI)"
            ) {
                this.publico_alvo = [{ id: 8, value: "IDOSOS" }];
            }
            if (
                subtipo ==
                "SAICA (SERVIÇO DE ACOLHIMENTO INSTITUCIONAL PARA CRIANÇAS E ADOLESCENTES)"
            ) {
                this.publico_alvo = [
                    { id: 1, value: "CRIANÇAS DE 0 A 12 ANOS" },
                    { id: 2, value: "ADOLESCENTES 13 A 17 ANOS" },
                ];
            }
        },
        getUnidades() {
            this.load = true;
            axios
                .get(`api/dashboard/acolhimentos/getunidades`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => (this.load = false));
        },
        submit() {
            this.load = true;
            axios
                .post("api/dashboard/acolhimento/storeunidade", {
                    item: this.item,
                })
                .then((response) => {
                    this.$emit("submit");
                    this.$snack.success({
                        button: false,
                        text: "Vagas cadastradas com sucesso.",
                    });
                    this.load = false;
                })
                .finally(() => {
                    this.item = "";
                    this.clear();
                    this.$bvModal.hide("cadastrar-vaga-unidade");
                });
        },
        clear() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.getUnidades();
        },
    },
};
</script>
